import { render } from "./ProfileHomeFeedSubpage.vue?vue&type=template&id=a79249a8&scoped=true"
import script from "./ProfileHomeFeedSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileHomeFeedSubpage.vue?vue&type=script&lang=js"

import "./ProfileHomeFeedSubpage.vue?vue&type=style&index=0&id=a79249a8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79249a8"]])

export default __exports__